require("../docs-content/docs-content");

const adminRoot = document.querySelector("[data-admin-root]");
const MAX_POLICY_BYTES = 8 * 1024 * 1024;
const ALLOWED_POLICY_EXT = /\.(pdf|doc|docx|rtf)$/i;

function initAdminDocsContent() {
  const store = window.NMDocsContent;
  if (!store || !adminRoot || window.NMAdminDocsContent) return;

  const fileInput = document.querySelector("#docs-privacy-file");
  const preview = document.querySelector("[data-docs-privacy-preview]");
  const filename = document.querySelector("[data-docs-privacy-filename]");
  const openLink = document.querySelector("[data-docs-privacy-open]");
  const resetBtn = document.querySelector("[data-docs-privacy-reset]");
  const emptyHint = document.querySelector("[data-docs-privacy-empty]");
  const note = document.querySelector("[data-docs-privacy-note]");
  const error = document.querySelector("[data-docs-privacy-error]");
  const field = document.querySelector("[data-docs-field='privacyFile']");

  function hideMessages() {
    if (note) note.hidden = true;
    if (error) error.hidden = true;
    field?.classList.remove("has-error");
  }

  function showError(message) {
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
    field?.classList.add("has-error");
  }

  function showNote() {
    if (note) note.hidden = false;
  }

  function renderPreview(url, fileName) {
    const hasFile = Boolean(url);
    if (filename) filename.textContent = hasFile ? (fileName || "Документ") : "";
    if (openLink) {
      openLink.hidden = !hasFile;
      const safeUrl = hasFile
        ? (window.NMSanitize?.safeHref?.(url, { allowData: true }) || "#")
        : "#";
      openLink.setAttribute("href", safeUrl);
    }
    if (preview) preview.hidden = !hasFile;
    if (emptyHint) emptyHint.hidden = hasFile;
    if (fileInput) fileInput.value = "";
  }

  function renderDocsAdmin() {
    const data = store.getDocsData();
    hideMessages();
    renderPreview(data.privacyPolicy.url, data.privacyPolicy.fileName);
  }

  async function persist(privacyPolicy) {
    try {
      await store.saveDocsData({ privacyPolicy });
      renderPreview(privacyPolicy.url, privacyPolicy.fileName);
      window.NMDocsContent.hydratePublicDocs();
    } catch (err) {
      showError(err.message || "Не удалось сохранить документы");
    }
  }

  if (fileInput) {
    fileInput.addEventListener("change", async () => {
      const file = fileInput.files?.[0];
      if (!file) return;
      hideMessages();

      if (!ALLOWED_POLICY_EXT.test(file.name) || file.size > MAX_POLICY_BYTES) {
        showError("Загрузите PDF, DOC, DOCX или RTF до 8 МБ");
        fileInput.value = "";
        return;
      }

      if (!window.NMApi?.uploadFile) {
        showError("Не удалось загрузить файл");
        return;
      }

      try {
        const uploaded = await window.NMApi.uploadFile(file);
        persist({
          url: uploaded.url,
          fileName: uploaded.name || file.name,
        });
        showNote();
      } catch (err) {
        showError(err.message || "Не удалось загрузить файл");
        fileInput.value = "";
      }
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      hideMessages();
      persist({ url: "", fileName: "" });
      showNote();
    });
  }

  window.NMAdminDocsContent = {
    renderDocsAdmin,
  };

  renderDocsAdmin();
}

if (adminRoot) {
  initAdminDocsContent();
  window.setTimeout(initAdminDocsContent, 0);
}
